import React from 'react';
import { ACCOMMODATIONS_ACTIONS } from './Accommodations.constants';
import { CustomComponentsProps } from '@website-editor/customComponents';
import { AddAccommodations } from './pages/AddAccommodations';
import { CustomProperty } from './pages/CustomProperty';
import { Hotel } from './pages/Hotel';

interface AccommodationsNavigationsProps
  extends CustomComponentsProps,
    Readonly<{
      componentId: string;
    }> {}

export const getAccommodationsNavigations = (props: AccommodationsNavigationsProps) => {
  const AddAccommodationsList = (
    <AddAccommodations
      type={ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_ADD}
      {...props}
    />
  );

  const HotelAdd = (
    <Hotel
      type={ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_HOTEL_ADD}
      {...props}
    />
  );
  const HotelEdit = (
    <Hotel
      type={ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_HOTEL_EDIT}
      {...props}
      isEditMode
    />
  );

  const CustomPropertyAdd = (
    <CustomProperty
      type={ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_CUSTOM_PROPERTY_ADD}
      {...props}
    />
  );
  const CustomPropertyEdit = (
    <CustomProperty
      type={ACCOMMODATIONS_ACTIONS.ACCOMMODATIONS_CUSTOM_PROPERTY_EDIT}
      {...props}
      isEditMode
    />
  );

  return [AddAccommodationsList, HotelAdd, HotelEdit, CustomPropertyAdd, CustomPropertyEdit];
};
